import { LayoutHOC } from 'base/ui/layout/layout';

import { ProjectManagementRoutes } from './routes';
import createProjectDetailReport from './projectDetailReport';

export const createProjectManagementPage = (layoutHOC: LayoutHOC) => {
  const ProjectDetailReport = createProjectDetailReport();
  const ProjectManagementPage = layoutHOC(ProjectManagementRoutes);

  return () => <ProjectManagementPage DetailReport={ProjectDetailReport} />;
};
